"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pkgName = exports.USER_SESSION_JOURNEY_STATUS = exports.UPSELL_ACCESSORIES_CHARACTERISTICS_NAMES = exports.UNLIMITED_VALUE = exports.UNLIMITED_GROUP_NAME = exports.THEMES = exports.TAP_TEXT_MAP = exports.STEP_TYPES = exports.SLIDER_STYLES = exports.SHARED_SERVICES = exports.RECOMMENDATION_TIER = exports.RECOMMENDATION_PAGE_INDEX = exports.QUESTION_VIEW_TYPE = exports.QUESTION_TYPE = exports.QUESTION_ID = exports.PRODUCT_TYPES = exports.PRODUCT_DISPLAY_ORDER = exports.PRICE_TYPES = exports.PLAN_TYPES = exports.PAGES = exports.MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM = exports.MODAL_MAX_SIZES = exports.MARKETS_MAP = exports.MARKETING_ID = exports.IMAGE_URLS = exports.GOOGLE_MAPS_LOCALS = exports.FLOATER_CLOSED_EVENTS = exports.FLAGS = exports.ERROR_IMAGE = exports.DYNAMIC_PAGES = exports.DUPLICATE_REQUEST_CANCELLATION = exports.DISPLAYED_PRODUCTS_ORDER = exports.COMPARISON_HIDDEN_VALUES = exports.COMPARISON_CATEGORY_ORDER = exports.CHARACTERISTIC_IDS = exports.CHARACTERISTIC_ICON_MAP = exports.CHARACTERISTIC = exports.BUSINESS_SOLUTION_URL_SPEC_NAME = exports.BUDGET_QUESTION_IDS = exports.APP_SHADOW_DOM_STYLES_SLOT_ID = exports.APP_SHADOW_DOM_ROOT_CONTAINER_ID = exports.APP_ROOT_ID = exports.API_PATH = exports.ALTERNATIVE_RECOMMENDATION_FLAGS = exports.ADDRESS_TYPE = exports.ADDON_PRICE_INFO_NAME = exports.ADDON_CHARACTERISTIC_NAME = exports.ADDITIONAL_PLANS_CHARACTERISTIC = void 0;
var _package = _interopRequireDefault(require("../../package.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const pkgName = _package.default.name;
// This must match the root ID provided in PWA, and must be changed manually in index.html
exports.pkgName = pkgName;
const APP_ROOT_ID = 'gs-app';
exports.APP_ROOT_ID = APP_ROOT_ID;
const APP_SHADOW_DOM_ROOT_CONTAINER_ID = 'gs-app-shadow';
exports.APP_SHADOW_DOM_ROOT_CONTAINER_ID = APP_SHADOW_DOM_ROOT_CONTAINER_ID;
const APP_SHADOW_DOM_STYLES_SLOT_ID = 'gs-app-styles';
exports.APP_SHADOW_DOM_STYLES_SLOT_ID = APP_SHADOW_DOM_STYLES_SLOT_ID;
const API_PATH = {
  GS_JOURNEY: '/guidedSelling/v1',
  PRODUCT_CATALOG: '/tmf-api/productCatalogManagement/v4',
  AVAILABILITY_CHECK: '/availabilityCheck/v1'
};
exports.API_PATH = API_PATH;
const QUESTION_ID = {
  BRANDS: 'preferred-device-brand',
  BUDGET: 'preferred-device-price',
  ADDRESS_SEARCH: 'addressSearch',
  NUM_OF_PLANS: 'numberOfPlans',
  PLAN_NUMBER: 'numberPlans',
  ROAMING: 'roaming',
  ONE_PLAN: 'onePlan'
};
exports.QUESTION_ID = QUESTION_ID;
const BUDGET_QUESTION_IDS = ['preferred-device-price', 'preferred-plan-price', 'preferred-device-and-plan-price'];
exports.BUDGET_QUESTION_IDS = BUDGET_QUESTION_IDS;
const PAGES = {
  QUESTIONNAIRE: 'QUESTIONNAIRE',
  SUMMARY: 'SUMMARY',
  RECOMMENDATION: 'RECOMMENDATION',
  ERROR: 'ERROR',
  SEARCH_ERROR: 'SEARCH_ERROR',
  UPSELL: 'UPSELL',
  COMPARISON: 'COMPARISON',
  DYNAMIC: 'DYNAMIC',
  RECOMMENDATION_ERROR: 'RECOMMENDATION_ERROR'
};
exports.PAGES = PAGES;
const MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM = {
  md: 830,
  lg: 960,
  xl: 1024
};
exports.MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM = MODAL_MAX_SIZES_OVERRIDE_SHADOWDOM;
const MODAL_MAX_SIZES = {
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5
};
exports.MODAL_MAX_SIZES = MODAL_MAX_SIZES;
const QUESTION_TYPE = {
  CHOICES: 'choices',
  RANGE: 'range',
  SEARCH: 'search',
  MULTI: 'multi',
  IMAGE: 'image',
  ADDRESS_SEARCH: 'address-search',
  ADDRESS_INPUT: 'address-input',
  COVERAGE_CHECKER: 'coverage-checker',
  TEXT_INPUT: 'text-input',
  STOP_MESSAGE: 'stop-message',
  INTRO_SCREEN: 'intro_screen'
};
exports.QUESTION_TYPE = QUESTION_TYPE;
const QUESTION_VIEW_TYPE = {
  CHOICES: 'choices'
};
exports.QUESTION_VIEW_TYPE = QUESTION_VIEW_TYPE;
const GOOGLE_MAPS_LOCALS = {
  gr: {
    region: 'GR',
    language: 'el'
  },
  demo: {
    region: 'GR',
    language: 'en'
  }
};
exports.GOOGLE_MAPS_LOCALS = GOOGLE_MAPS_LOCALS;
const RECOMMENDATION_PAGE_INDEX = -1;

/**
 * PRODUCT CATALOG
 */
exports.RECOMMENDATION_PAGE_INDEX = RECOMMENDATION_PAGE_INDEX;
const RECOMMENDATION_TIER = {
  RECOMMENDED: 'recommended',
  PREMIUM: 'premium',
  BUDGET: 'budget',
  ALTERNATIVE: 'alternative'
};
exports.RECOMMENDATION_TIER = RECOMMENDATION_TIER;
const CHARACTERISTIC_ICON_MAP = {
  Battery: 'battery',
  'Battery Life': 'battery',
  'Battery Hours': 'battery',
  Capacity: 'accelerometer',
  'Screen Size': 'screen-size',
  'Display Resolution': 'multiscreen',
  'Camera Resolution': 'camera',
  'Back Camera Resolution': 'camera',
  'Front Camera Resolution': 'camera',
  'Release Year': 'calendar-month',
  memory: 'e-sim',
  Cameraa: 'camera',
  Dimensions: 'mobile',
  Weight: 'mobiles',
  ram: 'e-sim',
  DATA_NATIONAL: 'data',
  VOICE_ALLNET: 'call',
  SMS_ALLNET: 'sms',
  VODAFONE_TV: 'tv',
  NETWORK_5G: '5g',
  GB_CONTROL: 'padlock-close',
  UNIQUE_GIFTS: 'all-rewards',
  'Youtube Premium': 'youtube-premium',
  'Spotify Premium': 'spotify',
  'Amazon Prime': 'amazon-prime',
  'Eco Rating': 'environment',
  'Ip Rating': 'anti-shock',
  '5g': '5g',
  'Sim Type': 'sim'
};
exports.CHARACTERISTIC_ICON_MAP = CHARACTERISTIC_ICON_MAP;
const UNLIMITED_VALUE = 9999999;
exports.UNLIMITED_VALUE = UNLIMITED_VALUE;
const UNLIMITED_GROUP_NAME = 'unlimited';
exports.UNLIMITED_GROUP_NAME = UNLIMITED_GROUP_NAME;
const USER_SESSION_JOURNEY_STATUS = {
  NEW_USER: 'NEW_USER',
  RETURNING_USER_START: 'RETURNING_USER_START',
  RETURNING_USER_QUESTIONNAIRE: 'RETURNING_USER_QUESTIONNAIRE',
  RETURNING_USER_RECOMMENDATION: 'RETURNING_USER_RECOMMENDATION'
};
exports.USER_SESSION_JOURNEY_STATUS = USER_SESSION_JOURNEY_STATUS;
const PRODUCT_TYPES = {
  HANDSET: 'HANDSET',
  PLAN: 'PLAN',
  BROADBAND: 'BROADBAND',
  ACCESSORY: 'ACCESSORY',
  INSURANCE: 'INSURANCE',
  CONNECTIVITY_PLAN: 'CONNECTIVITY_PLAN',
  BUSINESS_SOLUTION: 'BUSINESS_SOLUTION',
  AIRTIME_PLAN: 'AIRTIME_PLAN'
};
exports.PRODUCT_TYPES = PRODUCT_TYPES;
const COMPARISON_CATEGORY_ORDER = ['recommended', 'premium', 'alternative', 'budget'];
exports.COMPARISON_CATEGORY_ORDER = COMPARISON_CATEGORY_ORDER;
const STEP_TYPES = {
  HANDSET: 'HANDSET',
  PLAN: 'PLAN',
  AIRTIME_PLAN: 'AIRTIME_PLAN',
  UPSELL: 'UPSELL',
  BROADBAND: 'BROADBAND',
  BUSINESS_SOLUTION: 'BUSINESS_SOLUTION'
};
exports.STEP_TYPES = STEP_TYPES;
const PRICE_TYPES = {
  RECURRING: 'recurring',
  UP_FRONT: 'upfront',
  ADVANCE_PAYMENT: 'advancePayment',
  DISCOUNT: 'discount',
  CUSTOMER_DISCOUNT: 'existing-customer-discount',
  ONLINE_DISCOUNT: 'online-discount',
  LIST_PRICE: 'listPrice',
  COMMERCE_PRICE: 'commerce',
  LIST_ADDITIONAL_PLAN_PRICE: 'listAdditionalPlanPrice',
  COMMERCE_ADDITIONAL_PLAN_PRICE: 'commerceAdditionalPlanPrice',
  RECURRING_TOTAL_1: 'recurring-total1',
  MONTHLY_DISCOUNT: 'monthly-discount'
};
exports.PRICE_TYPES = PRICE_TYPES;
const MARKETS_MAP = {
  cl: 'cl',
  it: 'it',
  uk: 'uk',
  gr: 'gr',
  demo: 'demo',
  ie: 'ie',
  marketplace: 'marketplace',
  maac_ie: 'maac_ie',
  sa: 'sa',
  pe: 'pe',
  de: 'de'
};
exports.MARKETS_MAP = MARKETS_MAP;
const DYNAMIC_PAGES = {
  FULL_SPECS: 'FULL_SPECS',
  UPSELL_DETAILS: 'UPSELL_DETAILS',
  UPSELL_CONNECTIVITY_PLAN: 'UPSELL_CONNECTIVITY_PLAN',
  INSURANCE_DETAILS: 'INSURANCE_DETAILS',
  WARNING_SCREEN: 'WARNING_SCREEN'
};
exports.DYNAMIC_PAGES = DYNAMIC_PAGES;
const UPSELL_ACCESSORIES_CHARACTERISTICS_NAMES = {
  WIFI_ONLY: 'Wifi Only'
};
exports.UPSELL_ACCESSORIES_CHARACTERISTICS_NAMES = UPSELL_ACCESSORIES_CHARACTERISTICS_NAMES;
const IMAGE_URLS = {
  EMAIL_HEADER_ICON: 'https://imgtr.ee/images/2023/04/27/8P5yQ.png'
};
exports.IMAGE_URLS = IMAGE_URLS;
const ERROR_IMAGE = 'data:image/png;base64,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';
exports.ERROR_IMAGE = ERROR_IMAGE;
const BUSINESS_SOLUTION_URL_SPEC_NAME = 'businessSolutionUrl';
exports.BUSINESS_SOLUTION_URL_SPEC_NAME = BUSINESS_SOLUTION_URL_SPEC_NAME;
const PLAN_TYPES = {
  PayG: 'payAsYouGo'
};
exports.PLAN_TYPES = PLAN_TYPES;
const THEMES = {
  ENTEL: 'entel',
  MARKETPLACE: 'marketplace',
  GERMANY: 'germany'
};
exports.THEMES = THEMES;
const ADDITIONAL_PLANS_CHARACTERISTIC = 'NUM_PLANS';
exports.ADDITIONAL_PLANS_CHARACTERISTIC = ADDITIONAL_PLANS_CHARACTERISTIC;
const DISPLAYED_PRODUCTS_ORDER = ['recommended', 'budget', 'alternative', 'premium', 'budget'];
exports.DISPLAYED_PRODUCTS_ORDER = DISPLAYED_PRODUCTS_ORDER;
const SLIDER_STYLES = {
  BORDERED: 'bordered'
};
exports.SLIDER_STYLES = SLIDER_STYLES;
const ALTERNATIVE_RECOMMENDATION_FLAGS = {
  ALTERNATIVE_PLANS_FLAG: 'alternative-plan-recommendation'
};
exports.ALTERNATIVE_RECOMMENDATION_FLAGS = ALTERNATIVE_RECOMMENDATION_FLAGS;
const COMPARISON_HIDDEN_VALUES = ['no'];
exports.COMPARISON_HIDDEN_VALUES = COMPARISON_HIDDEN_VALUES;
const ADDON_CHARACTERISTIC_NAME = 'productName';
exports.ADDON_CHARACTERISTIC_NAME = ADDON_CHARACTERISTIC_NAME;
const ADDON_PRICE_INFO_NAME = 'productDescription';
exports.ADDON_PRICE_INFO_NAME = ADDON_PRICE_INFO_NAME;
const SHARED_SERVICES = 'Vodafone Services';
exports.SHARED_SERVICES = SHARED_SERVICES;
const TAP_TEXT_MAP = {
  [RECOMMENDATION_TIER.RECOMMENDED]: 'recommended-plan',
  [RECOMMENDATION_TIER.PREMIUM]: 'premium-plan',
  [RECOMMENDATION_TIER.ALTERNATIVE]: 'alternative-plan',
  [RECOMMENDATION_TIER.BUDGET]: 'budget-plan'
};
exports.TAP_TEXT_MAP = TAP_TEXT_MAP;
const FLAGS = {
  IS_CUSTOMER: 'isCustomer',
  PLAN_PORT_LINE: 'planPortLine',
  BOTH_FLOW: 'both-flow',
  NEXT_FLOW: 'nextFlow',
  NEW_CUSTOMER: 'newCustomer',
  ADDITIONAL_PLAN: 'additional-plans',
  PLAN: 'plan'
};
exports.FLAGS = FLAGS;
const FLOATER_CLOSED_EVENTS = {
  CLOSED_BY_ICON: 'close_by_icon',
  CLOLSED_BY_BTN: 'close_by_btn'
};
exports.FLOATER_CLOSED_EVENTS = FLOATER_CLOSED_EVENTS;
const CHARACTERISTIC_IDS = {
  DETAILS_LINK: 'detailsLink'
};
exports.CHARACTERISTIC_IDS = CHARACTERISTIC_IDS;
const CHARACTERISTIC = {
  RELEASE_YEAR: 'Release Year',
  TECHNOLOGY: 'TECHNOLOGY'
};
exports.CHARACTERISTIC = CHARACTERISTIC;
const PRODUCT_DISPLAY_ORDER = [PRODUCT_TYPES.HANDSET, PRODUCT_TYPES.PLAN, PRODUCT_TYPES.BROADBAND, PRODUCT_TYPES.ACCESSORY, PRODUCT_TYPES.INSURANCE, PRODUCT_TYPES.CONNECTIVITY_PLAN, PRODUCT_TYPES.BUSINESS_SOLUTION, PRODUCT_TYPES.AIRTIME_PLAN];
exports.PRODUCT_DISPLAY_ORDER = PRODUCT_DISPLAY_ORDER;
const ADDRESS_TYPE = {
  CITY: 'city',
  ZIPCODE: 'zipcode'
};
exports.ADDRESS_TYPE = ADDRESS_TYPE;
const DUPLICATE_REQUEST_CANCELLATION = 'DUPLICATE_REQUEST_CANCELLATION';
exports.DUPLICATE_REQUEST_CANCELLATION = DUPLICATE_REQUEST_CANCELLATION;
const MARKETING_ID = 'marketingId';
exports.MARKETING_ID = MARKETING_ID;